var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.000244141C15.5228 0.000244141 20 4.4774 20 10.0002C20 15.5231 15.5228 20.0002 10 20.0002C4.47715 20.0002 0 15.5231 0 10.0002C0 4.4774 4.47715 0.000244141 10 0.000244141ZM10 2.00024C5.58172 2.00024 2 5.58197 2 10.0002C2 14.4185 5.58172 18.0002 10 18.0002C14.4183 18.0002 18 14.4185 18 10.0002C18 5.58197 14.4183 2.00024 10 2.00024ZM15.5942 5.76388C16.0234 6.11144 16.0896 6.74114 15.742 7.17035L10.0781 14.1647C9.9177 14.3628 9.69718 14.4835 9.46402 14.522L9.3466 14.5343C9.11054 14.5452 8.86974 14.4729 8.67164 14.3125L5.56306 11.7952C5.13385 11.4476 5.06767 10.8179 5.41523 10.3887C5.7628 9.95953 6.3925 9.89335 6.8217 10.2409L9.153 12.1282L14.1877 5.91171C14.5353 5.4825 15.165 5.41632 15.5942 5.76388Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.cfda55c94d24f5186e730b87c4dbfbdf.svg";
export { ForwardRef as ReactComponent };